export const Nav = [
  {
    label: 'Designers',
    href: '/?categories=art-and-design',
    subItems: [
      {
        label: 'Illustration',
        href: '/?categories=art-and-design%5Cillustration',
      },
      {
        label: 'Graphic Design',
        href: '/?categories=art-and-design%5Cgraphic-design',
      },
      {
        label: 'Mockup',
        href: '/?categories=art-and-design%5Cmockup',
      },
      {
        label: 'Art',
        href: '/?categories=art-and-design%5Cart',
      },
      {
        label: 'UI & UX Design',
        href: '/?categories=art-and-design%5Cui-and-ux-design',
      },
    ],
  },
  {
    label: 'Marketers',
    href: '/?categories=business-and-marketing',
    subItems: [
      {
        label: 'Entrepreneurship',
        href: '/?categories=business-and-marketing%5Centrepreneurship',
      },
      {
        label: 'Marketing',
        href: '/?categories=business-and-marketing%5Cmarketing',
      },
      {
        label: 'Branding',
        href: '/?categories=business-and-marketing%5Cbranding',
      },
      {
        label: 'Products',
        href: '/?categories=business-and-marketing%5Cproducts',
      },
      {
        label: 'Ecommerce',
        href: '/?categories=business-and-marketing%5Cecommerce',
      },
      {
        label: 'Real Estate',
        href: '/?categories=business-and-marketing%5Creal-estate',
      },
      {
        label: 'Job & Career',
        href: '/?categories=business-and-marketing%5Cjob-and-career',
      },
    ],
  },
  {
    label: 'Game & Developers',
    href: '/?categories=game-and-software-development',
    subItems: [
      {
        label: '2D',
        href: '/?categories=game-and-software-development%5C2d',
      },
      {
        label: '3D',
        href: '/?categories=game-and-software-development%5C3d',
      },
      {
        label: 'Coding',
        href: '/?categories=game-and-software-development%5Ccoding',
      },
      {
        label: 'UI & UX Design',
        href: '/?categories=game-and-software-development%5Cui-and-ux-design',
      },
    ],
  },
  {
    label: 'Creators',
    href: '/?categories=photography-and-video',
    subItems: [
      {
        label: 'People',
        href: '/?categories=photography-and-video%5Cpeople',
      },
      {
        label: 'Animal',
        href: '/?categories=photography-and-video%5Canimal',
      },
      {
        label: 'Food & Beverages',
        href: '/?categories=photography-and-video%5Cfood-and-beverages',
      },
      {
        label: 'Nature',
        href: '/?categories=photography-and-video%5Cnature',
      },
      {
        label: 'Landscape',
        href: '/?categories=photography-and-video%5Clandscape',
      },
      {
        label: 'Sport',
        href: '/?categories=photography-and-video%5Csport',
      },
      {
        label: 'Architecture',
        href: '/?categories=photography-and-video%5Carchitecture',
      },
      {
        label: 'Vehicle',
        href: '/?categories=photography-and-video%5Cvehicle',
      },
      {
        label: 'Fashion & Lifestyle',
        href: '/?categories=photography-and-video%5Cfashion-and-lifestyle',
      },
      {
        label: 'Business',
        href: '/?categories=photography-and-video%5Cbusiness',
      },
    ],
  },
  {
    label: 'Writers',
    href: '/?categories=productivity-and-writing',
    subItems: [
      {
        label: 'Writing',
        href: '/?categories=productivity-and-writing%5Cwriting',
      },
      {
        label: 'Sport & Health',
        href: '/?categories=productivity-and-writing%5Csport-and-health',
      },
      {
        label: 'Relationships',
        href: '/?categories=productivity-and-writing%5Crelationships',
      },
      {
        label: 'Personal',
        href: '/?categories=productivity-and-writing%5Cpersonal',
      },
    ],
  },
];

export const NavGenerate = [
  {
    label: 'Overview',
    href: '/my-consistent-ai/overview',
  },
  // TODO: Uncomment this when we have a discover page
  // {
  //   label: 'Discover',
  //   href: '/my-consistent-ai/discover',
  // },
  {
    label: 'Create New Model',
    href: '/my-consistent-ai/train',
  },
];
